export enum AccessScope {
  Global = 'Global',
  Sales = 'Sales',
  User = 'User',
}
